import { Player, TrackInfo, TrackType } from 'fl-player-interface';
import { ResourceVm } from 'qp-ui-interface';
import { LocalStorageKeys } from '../../../shared/LocalStorageKeys';
import { ScreenService } from '../../../shared/services/screen/screen.service';
import { getSelectedWatchLangName } from '../../../shared/utils/LanguageUtils';
import { getDrmScheme } from '../../../shared/utils/PlaybackUtils';
import { NRPlaybackStatistics, PlaybackDrmInfo, SubtitleInfo } from '../models/newrelic.model';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';

const getActiveLanguage = (trackType: TrackType, player: Player): any => {
  const activeAudioTrack = player?.getActiveTracks()?.find((track: TrackInfo) => {
    return track.type === trackType;
  });

  return activeAudioTrack?.language || 'OFF';
};

export const getSubtitleInfo = (player: Player, localStorage: LocalStorageService): SubtitleInfo => {
  const ccEnabled = player?
    !!(player?.getActiveTracks()?.find((element) => element?.type === 'text') !== undefined) :
    localStorage.getItem(LocalStorageKeys.SUBTITLES_LANGUAGE) !== 'off';
  return {
    audioLanguage: getSelectedWatchLangName(localStorage),
    subtitleLanguage: getActiveLanguage(TrackType.TEXT, player),
    ccEnabled,
  };
};

export const getPlaybackDrmInfo = (): PlaybackDrmInfo => {
  return {
    drmName: getDrmScheme().toString(),
    drmVersion: 'NA',
  };
};

export const getNRPlaybackStatistics = (
  player: Player,
  resource: ResourceVm,
  screenService?: ScreenService,
): NRPlaybackStatistics => {
  const video = document.getElementsByTagName('video')[0];
  const playbackStatistics = player?.playbackStatistics;
  const runningTime = resource?.runningTime;
  const durationHour = runningTime?.includes('h') ? parseInt(runningTime, 10) * 3600 : '';
  const durationMin = durationHour !== '' ? parseInt(runningTime?.split(' ')[1], 10) * 60 : parseInt(runningTime, 10) * 60;
  const contentDuration = durationHour !== '' ? durationHour + durationMin : durationMin;
  return {
    contentDurationSec: player?.duration ? player?.duration : Math.floor(video?.duration) || contentDuration,
    videoResolution: `${playbackStatistics?.width}:${playbackStatistics?.height}`,
    currentBandwidthKb:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      playbackStatistics?.variantBitrate || window.navigator?.connection?.downlink,
    highestVariantBandwidthKb: player?.availableBitrates?.[player?.availableBitrates?.length - 1] || -1,
    lowestVariantBandwidthKb: player?.availableBitrates?.[0] || -1,
    lastPlayedVariant: playbackStatistics?.variantBitrate,
    lastAttemptedVariant: playbackStatistics?.variantBitrate,
    searchItemPosition: screenService?.searchItemPosition,
    observedBandwidth: playbackStatistics?.requiredBandwidth || 0,
    estimatedBandwidth: playbackStatistics?.estimatedBandwidth || 0,
    videoBitrate: playbackStatistics?.videoBitrate || 0,
    playerLoadLatency: playbackStatistics?.loadLatency || 0,
  };
};
